/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_blog_updated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.date}`)
};

const es_blog_updated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actualizado el ${i?.date}`)
};

const de_blog_updated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualisiert am ${i?.date}`)
};

const nl_blog_updated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bijgewerkt op ${i?.date}`)
};

const fr_blog_updated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mis à jour le ${i?.date}`)
};

const it_blog_updated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aggiornato il ${i?.date}`)
};

const pt_br2_blog_updated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atualizado em ${i?.date}`)
};

const pt_blog_updated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atualizado em ${i?.date}`)
};

const ja_blog_updated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`更新日: ${i?.date}`)
};

const zh_blog_updated_on = /** @type {(inputs: { date: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`更新于 ${i?.date}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ date: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const blog_updated_on = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.blog_updated_on(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("blog_updated_on", locale)
	if (locale === "en") return en_blog_updated_on(inputs)
	if (locale === "es") return es_blog_updated_on(inputs)
	if (locale === "de") return de_blog_updated_on(inputs)
	if (locale === "nl") return nl_blog_updated_on(inputs)
	if (locale === "fr") return fr_blog_updated_on(inputs)
	if (locale === "it") return it_blog_updated_on(inputs)
	if (locale === "pt-BR") return pt_br2_blog_updated_on(inputs)
	if (locale === "pt") return pt_blog_updated_on(inputs)
	if (locale === "ja") return ja_blog_updated_on(inputs)
	return zh_blog_updated_on(inputs)
};